/* eslint-disable */
import throwI18nInvalidLabelLengthError from '../../../Errors/I18n/I18nInvalidLabelLength.error';
import throwI18nInvalidLabelTypeError from '../../../Errors/I18n/I18nInvalidLabelType.error';
import isString from '../../Is/String/IsString.support';

/**
 * Determine if a provided `label` is indeed a valid `label`
 * @export
 * @param {string} label The `label` to check
 * @returns {boolean} Whether or not the provided `label` is indeed valid
 */
const i18nValidateLabel = (label) => {
  if (!isString(label)) {
    return throwI18nInvalidLabelTypeError(label);
  }
  if (label.length === 0) {
    return throwI18nInvalidLabelLengthError(label);
  }
  return true;
};

export default i18nValidateLabel;
